module.exports = __webpack_public_path__ + "img/19.64583907.png";